import styled from 'styled-components'
import theme from '../../theme'

export const ScreenWrapper = styled.section`
  background-color: ${theme.colors.background.color};
  min-height: 100vh;
  width: 100%;
  display: flex;
  // flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
`
type CardContainerProps = {
  listView: boolean
}
export const CardContainer = styled.div<CardContainerProps>`
  //  width: 90%;
  min-width: ${props => (props.listView ? '100%' : '40rem')};
  margin: 0;
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;

  ${props => (props.listView ? 'flex-direction: column;' : '')}

  padding: 2rem;
   @media(max-width:768px){
      width:100%;
      justify-content:center;
    }
`
export const ExpandedDropZone = styled.div`
  /*   width: 90%;
  min-width: 40rem; */
  margin: 0;
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
  background: #ffffff;
  border-radius: 25px;
  box-shadow: 4px 4px 18px -5px rgba(218, 221, 232, 0.8);
  //padding: 2rem;
`
